<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="show"
    :isUnitButton="isUnitButton"
    :isPlain="isPlain"
    :unitText="unitText"
    @cancel="show=false"
    @next="onConfirm">
    <div class="email-dialog">
      <p class="tip">
        {{message}}
      </p>
    </div>
  </dialog-component>
</template>
<script>
export default {
  name: 'newMessageDialog',
  data() {
    return {
      show: false,
      message: '',
      isUnitButton:false,
      isPlain:false,
      unitText:'Close',
      dialogData: {},
      promiseStatus: null,
    }
  },
  methods: {
    confirm() {
      return new Promise((resolve, reject) => {
        this.promiseStatus = {
          resolve,
          reject
        }
      })
    },
    // onCancel() {
    //   this.show = false
    // },
    onConfirm() {
      this.show = false
      this.promiseStatus.resolve()
    }
  }
}
</script>
<style lang="scss" scoped>
  .email-dialog{
    .tip{
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
  }
</style>
